module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4hmrF"))).then(() => parcelRequire('7Puiz'));